var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.24,
    height: 45.604,
    viewBox: "0 0 53.24 45.604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.499,
    cy: 1.097,
    r: 0.565,
    gradientTransform: "translate(0.981 -24.267) scale(0.857 1.264)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#008cca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003bf1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92fff1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0098ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00eff1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0098ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -22.589,
    y1: 0.499,
    x2: -21.589,
    y2: 0.499,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#40ff79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#3cef71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#31c55d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#20813d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#092411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.479,
    cy: 0.695,
    r: 0.501,
    gradientTransform: "matrix(-0.06, -0.998, 0.998, -0.06, -77.232, -149.334)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#009148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#005e2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00351a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#00180c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000603"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -107.524,
    cy: -35.353,
    r: 0.5,
    gradientTransform: "translate(0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: -113.223,
    cy: -42.256,
    r: 0.5,
    gradientTransform: "translate(0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: -37.137,
    cy: -13.242,
    r: 0.5,
    gradientTransform: "translate(0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: -89.127,
    cy: -33.313,
    r: 0.5,
    gradientTransform: "translate(0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: -171.483,
    cy: -78.314,
    r: 0.5,
    gradientTransform: "translate(0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: -177.698,
    cy: -55.133,
    r: 0.5,
    gradientTransform: "translate(0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: -238.448,
    cy: -98.776,
    r: 0.528,
    gradientTransform: "translate(0.023) scale(0.954 1)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: -117.666,
    cy: -41.088,
    r: 0.5,
    gradientTransform: "translate(0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ed140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#74c13b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5b972e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#325319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "icon-close",
    transform: "translate(0.001 -0.001)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "space"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    d: "M.88,37c1.82,7.09,47,12.44,50.75,5.06C55,35.36,52.47,8,49.56,3.22,45.59-3.3,6.49,1.28,3.28,6.41.28,11.2-1,29.64.88,37Z",
    fill: "url(#radial-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    d: "M1,35.74c1.81,6.85,46.73,10.69,50.47,3.57,3.39-6.46.87-31.19-2-35.8C45.52-2.78,6.56,1.63,3.36,6.58.38,11.2-.85,28.65,1,35.74Z",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    d: "M1.57,35.14C3.34,41.78,47.32,45.6,51,38.7c3.31-6.27.83-30.37-2-34.85C45.1-2.25,7,2,3.86,6.84.94,11.32-.26,28.26,1.57,35.14Z",
    fill: "url(#linear-gradient-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    d: "M16,13.44l3.18-2.68s14.17,9.89,20.4,19.07l-3,2.26A85.87,85.87,0,0,1,16,13.44Z",
    fill: "#1d6eff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1963",
    "data-name": "Path 1963",
    d: "M35.77,9.68l2.68,3.18s-8.27,13.68-19.07,20.4l-2.26-3A85.87,85.87,0,0,1,35.77,9.68Z",
    fill: "#1d6eff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1964",
    "data-name": "Path 1964",
    d: "M50.11,38.83A136.08,136.08,0,0,1,3.82,36.25s16.33,2.66,23.6,0C39.75,31.75,46.86,33.76,50.11,38.83Z",
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    d: "M15.57,12.61a1.28,1.28,0,1,1-.894.441A1.28,1.28,0,0,1,15.57,12.61Z",
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    d: "M15.72,13.52a.321.321,0,1,1-.33.34.36.36,0,0,1,.33-.34Z",
    fill: "#ffffab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    d: "M17.3,7.13a1.28,1.28,0,1,1-1.19,1.35A1.28,1.28,0,0,1,17.3,7.13Z",
    fill: "url(#radial-gradient-3)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1968",
    "data-name": "Path 1968",
    d: "M17.46,8.05a.35.35,0,0,1,.37.33.36.36,0,0,1-.71,0A.36.36,0,0,1,17.46,8.05Z",
    fill: "#ffffab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1969",
    "data-name": "Path 1969",
    d: "M16.28,22.84a1.28,1.28,0,1,1-1.2,1.35A1.28,1.28,0,0,1,16.28,22.84Z",
    fill: "url(#radial-gradient-4)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1970",
    "data-name": "Path 1970",
    d: "M16.43,23.76a.36.36,0,0,1,.38.33.35.35,0,0,1-.33.37.34.34,0,0,1-.38-.33.35.35,0,0,1,.33-.37Z",
    fill: "#ffffab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    d: "M10.28,4.33A3.57,3.57,0,1,1,6.93,8.11,3.57,3.57,0,0,1,10.28,4.33Z",
    fill: "url(#radial-gradient-5)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1972",
    "data-name": "Path 1972",
    d: "M10.71,6.89a1,1,0,1,1-.93,1.05,1,1,0,0,1,.93-1.05Z",
    fill: "#ffffab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    d: "M20.46,31.58a1.7,1.7,0,1,1-1.174.568,1.7,1.7,0,0,1,1.174-.568Z",
    fill: "url(#radial-gradient-6)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    d: "M20.66,32.8a.47.47,0,0,1,.5.44.46.46,0,0,1-.44.5.47.47,0,0,1-.5-.44.48.48,0,0,1,.44-.5Z",
    fill: "#ffffab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1975",
    "data-name": "Path 1975",
    d: "M5.32,36.08a.85.85,0,1,1-.8.9A.86.86,0,0,1,5.32,36.08Z",
    fill: "url(#radial-gradient-7)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M5.43,36.69a.24.24,0,0,1,.25.22.25.25,0,0,1-.23.25.24.24,0,0,1-.25-.22A.25.25,0,0,1,5.43,36.69Z",
    fill: "#ffffab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M29.27,21.45a.85.85,0,1,1-.8.9.84.84,0,0,1,.8-.9Z",
    fill: "url(#radial-gradient-8)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M29.38,22.06a.24.24,0,0,1,.25.22.25.25,0,0,1-.23.25.24.24,0,0,1-.25-.22A.25.25,0,0,1,29.38,22.06Z",
    fill: "#ffffab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M17.45,34.82a.607.607,0,1,1-.6.68.65.65,0,0,1,.6-.68Z",
    fill: "url(#radial-gradient-9)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M17.53,35.28a.17.17,0,0,1,.18.16.18.18,0,1,1-.18-.16Z",
    fill: "#ffffab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M27.32,34.3a1.33,1.33,0,1,1-.918.445A1.33,1.33,0,0,1,27.32,34.3Z",
    fill: "url(#radial-gradient-10)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M27.48,35.26a.366.366,0,1,1,.05.73.37.37,0,1,1-.05-.73Z",
    fill: "#ffffab"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    d: "M48.93,40.1c-.22-.76,1.79-4.22,2.3-4.21s.05,2.28-.25,2.81S49.05,40.48,48.93,40.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    d: "M4.48,6.72S33.59-4.48,49.07,4a33.76,33.76,0,0,1,2,8.24,21.42,21.42,0,0,1-14.17,6.3c-8,.55-15.74-9.63-22.46-10.89S4.48,6.72,4.48,6.72Z",
    fill: "url(#linear-gradient-4)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    d: "M3.89,8.74c-.56.08-2,4.43-1.88,5.14s1.77-1.54,2-2.74a4.92,4.92,0,0,0-.12-2.4Z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    d: "M4.13,8.05c-.68-.27.53-2.12,1.56-2.58s3.58-1,3.87-.51S4.89,8.35,4.13,8.05Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.870188af2257aae603d30a3923a2fc0c.svg";
export { ForwardRef as ReactComponent };